import { makeApiSpecFetcher } from '@mathflat/shared/@modules/ApiSpecFetcher/apiSpecFetcher.ts'

import maxios from '~/@common/utils/maxios.ts'

export const apiSpecFetcher = makeApiSpecFetcher(maxios)
